import { Typography } from "@mui/material";
import { useMemo } from "react";
import { Dialog } from "../../components/dialogs/Dialog";
import { useLocale } from "../../providers/LocaleProvider";

const ImportJobErrorDialog = (props: any) => {
  const { theme, onClose, open = false, competencies = [] } = props;
  const { translate } = useLocale();

  const isMultipleCompetencies = useMemo(() => competencies.length > 1, [competencies]);

  return (
    <Dialog
      open={open}
      theme={theme}
      onClose={onClose}
      fullWidth={true}
      maxWidth='sm'
      title={translate("settings.importJob")}
      actions={[
        {
          label: translate("common.cancel"),
          primary: true,
          variant: "filled",
          disabled: false,
          onClick: onClose
        }
      ]}
    >
      <Typography>
        {translate(
          isMultipleCompetencies
            ? "settings.importJobErrorMultiple"
            : "settings.importJobErrorSingle"
        )}
      </Typography>

      <ul>
        {competencies.map((task: any) => (
          <li key={task.id}>
            <Typography>{task.name}</Typography>
          </li>
        ))}
      </ul>
    </Dialog>
  );
};

export default ImportJobErrorDialog;
